// Curated categories derived from the long list in EditEntryDialog
interface UOMCategory {
  name: string
  units: readonly string[]
}

export const UOM_CATEGORIES: UOMCategory[] = [
  {
    name: 'Time',
    units: [
      'Day',
      'Hour',
      'Minute',
      'Month',
      'Quarter',
      'Second',
      'Week',
      'Year',
    ] as const,
  },
  {
    name: 'Quantity',
    units: [
      'Batch',
      'Box',
      'Bundle',
      'Carton',
      'Case',
      'Container',
      'Dozen',
      'Each',
      'Hundred',
      'Item',
      'Kit',
      'Lot',
      'Package',
      'Pair',
      'Pallet',
      'Piece',
      'Set',
      'Thousand',
      'Unit',
    ] as const,
  },
  {
    name: 'Weight',
    units: [
      'Gram',
      'Kilogram',
      'Long Ton',
      'Metric Ton',
      'Ounce',
      'Pound',
      'Short Ton',
      'Ton',
    ] as const,
  },
  {
    name: 'Length',
    units: [
      'Centimeter',
      'Foot',
      'Inch',
      'Kilometer',
      'Meter',
      'Mile',
      'Millimeter',
      'Yard',
    ] as const,
  },
  {
    name: 'Area',
    units: [
      'Acre',
      'Hectare',
      'Square Foot',
      'Square Inch',
      'Square Meter',
      'Square Mile',
      'Square Yard',
    ] as const,
  },
  {
    name: 'Volume',
    units: [
      'Barrel',
      'Cubic Foot',
      'Cubic Inch',
      'Cubic Meter',
      'Cubic Yard',
      'Fluid Ounce',
      'Gallon',
      'Liter',
      'Milliliter',
      'Pint',
      'Quart',
    ] as const,
  },
  {
    name: 'Service',
    units: [
      'Account',
      'Analysis',
      'Assessment',
      'Audit',
      'Call',
      'Certification',
      'Course',
      'Document',
      'Entry',
      'Evaluation',
      'Event',
      'Full-Time Equivalent (FTE)',
      'Inspection',
      'License',
      'Module',
      'Page',
      'Person',
      'Person-Day',
      'Person-Hour',
      'Person-Month',
      'Person-Year',
      'Query',
      'Record',
      'Report',
      'Request',
      'Response',
      'Sample',
      'Seat',
      'Session',
      'Subscription',
      'Test',
      'Training Hour',
      'Transaction',
      'User',
      'Visit',
    ] as const,
  },
  {
    name: 'Manufacturing/Construction',
    units: [
      'Assembly',
      'Bar',
      'Beam',
      'Block',
      'Board Foot',
      'Brick',
      'Coil',
      'Component',
      'Connection',
      'Fitting',
      'Joint',
      'Linear Foot',
      'Linear Meter',
      'Linear Yard',
      'Panel',
      'Pipe',
      'Reel',
      'Rod',
      'Roll',
      'Sheet',
      'Spool',
      'Subassembly',
      'System',
      'Tile',
      'Tube',
      'Valve',
    ] as const,
  },
  {
    name: 'Energy/Utility',
    units: [
      'BTU',
      'Barrel of Oil',
      'Cubic Foot of Gas',
      'Gallon of Fuel',
      'Kilowatt Hour (kWh)',
      'Megawatt Hour (MWh)',
      'Therm',
    ] as const,
  },
  {
    name: 'Data/Technology',
    units: [
      'API Call',
      'Bandwidth Unit',
      'CPU Hour',
      'Data Transfer (GB)',
      'Gigabit',
      'Gigabyte (GB)',
      'Instance Hour',
      'Megabit',
      'Petabyte (PB)',
      'Server Hour',
      'Storage Hour',
      'Terabyte (TB)',
    ] as const,
  },
  {
    name: 'Miscellaneous',
    units: [
      'Adapter',
      'Amplifier',
      'Attenuator',
      'Availability Unit',
      'Background Check',
      'Bandwidth',
      'Bay',
      'Bracket',
      'Bridge',
      'Cabinet',
      'Cable',
      'Capability',
      'Capacity Unit',
      'Change Request',
      'Channel',
      'Circuit',
      'Combiner',
      'Configuration',
      'Connector',
      'Conversion',
      'Converter',
      'Cord',
      'Coupler',
      'Customization',
      'Deliverable',
      'Delivery Order',
      'Deployment',
      'Duct',
      'Enclosure',
      'Endpoint',
      'Enhancement',
      'Facility',
      'Feature',
      'Filter',
      'Fix',
      'Fixture',
      'Frequency',
      'Function',
      'Gateway',
      'Harness',
      'Housing',
      'Hub',
      'Incident',
      'Installation',
      'Integration',
      'Interface',
      'Isolator',
      'Issue',
      'Iteration',
      'Link',
      'Location',
      'Maintenance Event',
      'Migration',
      'Milestone',
      'Modification',
      'Mounting',
      'Node',
      'Patch',
      'Pathway',
      'Performance Unit',
      'Phase',
      'Port',
      'Problem',
      'Rack Unit',
      'Raceway',
      'Region',
      'Release',
      'Repeater',
      'Resolution',
      'Response Time',
      'Route',
      'Router',
      'Sector',
      'Security Clearance',
      'Service Call',
      'Service Level',
      'Site',
      'Slot',
      'Socket',
      'Splitter',
      'Sprint',
      'Stage',
      'Switch',
      'Task Order',
      'Territory',
      'Throughput Unit',
      'Ticket',
      'Transformer',
      'Tray',
      'Update',
      'Uptime Hour',
      'Version',
      'Wire',
      'Work Order',
      'Zone',
    ] as const,
  },
]
